import { makeStyles } from '@material-ui/styles';
import { Timestamp } from '@bizzabo/collaboration-common';
import { Theme, Tag } from '@bizzabo/design-system';
import { isUserModeratorOnThisChannel } from '../../../utils/userUtils';

const UserBadgeNameSibling = ({ channel, message }) => {
    // This will work only for 100 first users => known by product
    const isModerator = isUserModeratorOnThisChannel(channel, message.user);
    const classes = useStyles({ isModerator });

    return (
        <div className={isModerator && classes.container}>
            {isModerator && <Tag tagText="Host" className={classes.tag} />}
            <Timestamp startTime={message.created_at} className={classes.timestamp} withDot />
        </div>
    );
};

const useStyles = makeStyles<Theme, { isModerator: boolean }>(
    theme => ({
        container: {
            display: 'flex',
            alignItems: 'center',
        },
        timestamp: {
            marginLeft: ({ isModerator }) => (!isModerator ? 0 : 4),
            display: 'block',
        },
        tag: {
            backgroundColor: theme.customization.interactive.C10,
        },
    }),
    { classNamePrefix: 'UserBadgeNameSibling' }
);

export default UserBadgeNameSibling;
